import styled from "styled-components";

import jarSrc from "../../images/not-available-jar.svg";

export const Root = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;

  @media (max-width: 1023px) {
    padding-top: 72px;
    padding-bottom: 100px;
  }

  @media (min-width: 1024px) {
    padding: 170px 0;
  }
`;

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-image: url(${jarSrc});
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  transform: rotate(2deg);

  @media (max-width: 1023px) {
    height: 153px;
    padding-top: 20px;
  }

  @media (min-width: 1024px) {
    height: 204px;
    padding-top: 10px;
  }
`;

export const Subtitle = styled.div`
  color: #c49f3f;
  font-family: "Rockwell";
  text-align: center;
  text-transform: uppercase;

  @media (max-width: 1023px) {
    font-size: 18px;
  }

  @media (min-width: 1024px) {
    font-size: 26px;
  }
`;

export const Title = styled.div`
  position: relative;
  color: #fff;
  font-family: "YWFT Ultramagnetic";
  text-align: center;
  text-transform: uppercase;

  @media (max-width: 1023px) {
    margin-top: 10px;
    font-size: 38px;
  }

  @media (min-width: 1024px) {
    margin-top: 10px;
    font-size: 70px;
  }

  &::before,
  &::after {
    content: "";
    position: absolute;
    background-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 19 19' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill='%23bb8b2b' d='M 11.086 13.344 L 17.628 16.034 L 13.918 10.011 L 18.5 4.621 L 11.624 6.289 L 7.914 0.267 L 7.375 7.32 L 0.5 8.988 L 7.043 11.68 L 6.505 18.733 L 11.086 13.344 Z'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-size: cover;

    @media (max-width: 1023px) {
      top: 10px;
      width: 16px;
      height: 16px;
    }

    @media (min-width: 1024px) {
      top: 25px;
      width: 20px;
      height: 20px;
    }
  }

  &::before {
    @media (max-width: 1023px) {
      left: -25px;
    }

    @media (min-width: 1024px) {
      left: -40px;
    }
  }

  &::after {
    @media (max-width: 1023px) {
      right: -25px;
    }

    @media (min-width: 1024px) {
      right: -40px;
    }
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;

  @media (max-width: 1023px) {
    margin-top: 32px;
    padding: 0 25px;
  }

  @media (min-width: 1024px) {
    max-width: 1550px;
    margin-top: 63px;
    padding: 0 60px;
  }

  .slick-slider {
    @media (max-width: 1023px) {
      max-width: 460px;
      margin: 0 auto;
    }
  }

  .slick-prev,
  .slick-next {
    top: 50%;
  }

  @media (max-width: 409px) {
    .slick-prev {
      left: -20px;
    }

    .slick-next {
      right: -20px;
    }
  }
`;

export const Image = styled.img`
  position: absolute;
  pointer-events: none;
  transition: all 300ms ease;

  @media (max-width: 1023px) {
    bottom: 50px;
    max-width: 330px;
  }

  @media (min-width: 1024px) {
    bottom: 75px;
    max-width: 400px;
  }
`;

export const SlideBody = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  position: relative;
  height: 426px;
  width: 100%;

  @media (min-width: 1024px) {
    padding-bottom: 25px;

    &::before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 11px;
      transition: all 300ms ease;
    }
  }
`;

export const Slide = styled.div`
  display: flex !important;
  flex-direction: column;
  align-items: center;
  position: relative;
  height: 100%;
  cursor: pointer;

  @media (min-width: 1024px) {
    width: 100%;
    padding-top: 100px;
    padding-left: 50px;
    padding-right: 50px;

    &:hover ${Image} {
      transform: translateY(-10px);
    }

    &:hover ${SlideBody}::before {
      transform: translateY(-10px);
    }
  }

  @media (min-width: 1280px) {
    padding-left: 50px;
    padding-right: 50px;
  }
`;

export const SlideTitle = styled.div`
  height: 24px;
  color: #fff;
  font-family: "YWFT Ultramagnetic";
  text-align: center;
  text-transform: uppercase;

  @media (max-width: 1023px) {
    margin-bottom: 19px;
    font-size: 24px;
    line-height: 1.42;
  }

  @media (min-width: 1024px) {
    margin-bottom: 22px;
    font-size: 28px;
    line-height: 1.21;
  }
`;

export const Action = styled.button`
  display: flex;
  align-items: center;
  width: 116px;
  height: 24px;
  padding: 3px 0 0;
  color: #c49f3f;
  font-family: "Rockwell";
  text-transform: uppercase;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12'%3E%3Cpath fill='%23c49f3f' d='M7.196 5.996 3.208 2.011a.75.75 0 0 1 0-1.064.76.76 0 0 1 1.067 0l4.519 4.516a.752.752 0 0 1 .022 1.039l-4.538 4.547a.753.753 0 1 1-1.067-1.064l3.985-3.989Z'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position-y: center;
  background-position-x: right;
  background-size: 12px;
  font-size: 14px;
  letter-spacing: 1.4px;
  transition: all 300ms ease;
  cursor: pointer;

  &:hover {
    background-position-x: 100%;
  }
`;
